import { createAsyncThunk } from '@reduxjs/toolkit';
import {  searchGlobalAPI } from './searchAPI';


// Set current query in Redux (no backend call)
export const setCurrentQuery = (query) => ({
  type: 'search/setCurrentQuery',
  payload: query
});


// Unified thunk for global search
export const fetchGlobalSearchResults = createAsyncThunk(
  'search/fetchGlobalResults',
  async (query, { rejectWithValue }) => {
    try {
      const data = await searchGlobalAPI(query);
      return {
        users: data.users || [],
        stocks: data.stocks || []
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Global search error');
    }
  }
);

// Clear search results manually (e.g., on blur or exit)
export const clearSearchResults = () => (dispatch) => {
  dispatch({ type: 'search/clearSearchResults' });
};
